const state = {
	data: {
		latestStories: [],
		bigStoryRight: [],
		bigStoryLeft: {},
		moreStories: []
	},
}

export default {
	state
}



// WEBPACK FOOTER //
// ./src/store/modules/stories.js